import { gql } from "@apollo/client";

export const createNotify = gql`
mutation($data: RequestsCreateInput!){
    createRequests(data: $data) {
      email
    }
  }
`